import api from '../..'

const newUsersList = (searchText = '', page = 1, perPage = 10) => {
  const q = {
    full_name_or_identifier_or_position_or_lms_profiles_name_or_area_name_cont:
      searchText,
    lms_active_true: true,
    s: ['name asc', 'lastname asc'],
  }

  return api
    .post(`users/search`, { page, per_page: perPage, q })
    .then(({ data }) => {
      return {
        data
      }
    })
}

export default newUsersList
